export default {"src":"/_next/static/media/MMM.520d2ec7.svg","height":18,"width":18};